export const ORDERS_PATIENTS_ACTION_TYPES = {
  setList: 'orders-patients-set-list',
  setListCount: 'orders-patients-set-list-count',
  setFilters: 'orders-patients-set-list-filters',
};